import Language from '../enums/Language'
import { isEnumVariant } from './enum'

/**
 * Checks if the provided value is a valid Language enum variant.
 * @param value The value to check.
 * @returns True if the value is a valid Language enum variant, false otherwise.
 */
export function isValidLanguage(value: string): value is Language {
  return isEnumVariant(value, Language)
}
